import React from "react"
import * as styles from "./Styles/PC.module.scss"
import classNames from "classnames/bind"
const cn = classNames.bind(styles)

import FilterRow from "../../Common/Filter/Row"
import CategoryModal from "../../Common/FilterModal/Category"
import LocationModal from "../../Common/FilterModal/Location"
import Loader from "../../Common/Loader"

const PC = (props) => {
  const handleLocationClick = (e) => {
    e.preventDefault()
    props.setShowLocationModal(true)
  }
  const handleCategoryClick = (e) => {
    e.preventDefault()
    props.setShowCategoryModal(true)
  }

  return (
    <React.Fragment>
      <div className={styles.background}>
        <h2 className={styles.title}>お店・施設の混雑情報</h2>
        <div className={styles.rows}>
          <FilterRow
            target={{ name: props.locationText }}
            fallback="現在地周辺"
            iconParam={{ type: "feather", name: "map" }}
            onClick={handleLocationClick}
          />
          <hr className="common-hr" />
          <FilterRow
            target={props.category}
            fallback="カテゴリを選ぶ"
            iconParam={{ type: "original", name: "building" }}
            onClick={handleCategoryClick}
          />
        </div>
        <div>
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault()
              if (!props.componentDisabled) {
                props.onSubmit(props.city, props.prefecture, props.category)
              }
            }}
          >
            <div
              className={cn(
                "searchButton",
                props.componentDisabled ? "searchButton--disabled" : ""
              )}
            >
              <Loader show={props.showLoader} color="white" small={true} />
              {!props.showLoader && <span>この条件でさがす</span>}
            </div>
          </a>
        </div>
      </div>
      <LocationModal
        {...props}
        locations={props.locations}
        show={props.showLocationModal}
        onHide={() => props.setShowLocationModal(false)}
        onChange={props.handleLocation}
      />
      <CategoryModal
        {...props}
        show={props.showCategoryModal}
        onHide={() => props.setShowCategoryModal(false)}
        onChange={props.handleCategory}
        placeCountByCategories={props.placeCountByCategories}
      />
    </React.Fragment>
  )
}
export default PC
